import React from 'react';

import PropTypes from 'prop-types';

import { NavLink as RouterNavLink } from 'react-router-dom';

import { Box, ListItem, ListItemButton } from '@mui/material';

const NavLinkLayout = ({ to, text, icon: Icon }) => (
  <ListItem disablePadding sx={{ mb: 0.5 }}>
    <RouterNavLink
      to={`/admin/${to}`}
      style={{ textDecoration: 'none', width: '100%' }}
      // eslint-disable-next-line react/no-children-prop
      children={({ isActive }) => (
        <ListItemButton
          selected={isActive}
          sx={{
            position: 'relative',
            borderRadius: 2,
            gap: 1.25,
            color: 'white',
            fontWeight: 600,
            transition: 'background-color .18s ease, padding-left .18s ease',
            '&:hover': { backgroundColor: 'rgba(255,255,255,0.08)', pl: 2.25 },
          }}
          variant='body1'
        >
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              width: 3,
              height: isActive ? 20 : 0,
              borderRadius: 3,
              bgcolor: '#fff',
              transition: 'height .25s cubic-bezier(0.22,1,0.36,1)',
            }}
          />
          {Icon && <Icon size={18} strokeWidth={1.8} />}
          {text}
        </ListItemButton>
      )}
    />
  </ListItem>
);

NavLinkLayout.propTypes = {
  text: PropTypes.string,
  to: PropTypes.string,
  icon: PropTypes.elementType,
};

export default NavLinkLayout;
